import { compose } from 'recompose';
import CRM from './crm';

const enhance = compose(

);

export default enhance(CRM);
